var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1998_93238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.660156,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1998_93238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.4101H12.75V11.6602H11.25V17.4101ZM12 9.94864C12.2288 9.94864 12.4207 9.87124 12.5755 9.71644C12.7303 9.56164 12.8077 9.36981 12.8077 9.14096C12.8077 8.91213 12.7303 8.7203 12.5755 8.56549C12.4207 8.41069 12.2288 8.33329 12 8.33329C11.7711 8.33329 11.5793 8.41069 11.4245 8.56549C11.2697 8.7203 11.1923 8.91213 11.1923 9.14096C11.1923 9.36981 11.2697 9.56164 11.4245 9.71644C11.5793 9.87124 11.7711 9.94864 12 9.94864ZM12.0016 22.1601C10.6877 22.1601 9.45268 21.9108 8.29655 21.4121C7.1404 20.9135 6.13472 20.2367 5.2795 19.3819C4.42427 18.527 3.74721 17.5218 3.24833 16.3662C2.74944 15.2105 2.5 13.9758 2.5 12.6618C2.5 11.3479 2.74933 10.1129 3.248 8.95674C3.74667 7.80059 4.42342 6.7949 5.27825 5.93969C6.1331 5.08445 7.13834 4.4074 8.29398 3.90851C9.44959 3.40963 10.6844 3.16019 11.9983 3.16019C13.3122 3.16019 14.5473 3.40952 15.7034 3.90819C16.8596 4.40685 17.8652 5.0836 18.7205 5.93844C19.5757 6.79329 20.2527 7.79853 20.7516 8.95416C21.2505 10.1098 21.5 11.3446 21.5 12.6585C21.5 13.9724 21.2506 15.2075 20.752 16.3636C20.2533 17.5197 19.5765 18.5254 18.7217 19.3806C17.8669 20.2359 16.8616 20.9129 15.706 21.4118C14.5504 21.9107 13.3156 22.1601 12.0016 22.1601ZM12 20.6602C14.2333 20.6602 16.125 19.8852 17.675 18.3352C19.225 16.7852 20 14.8935 20 12.6602C20 10.4268 19.225 8.53516 17.675 6.98516C16.125 5.43516 14.2333 4.66016 12 4.66016C9.76664 4.66016 7.87498 5.43516 6.32498 6.98516C4.77498 8.53516 3.99998 10.4268 3.99998 12.6602C3.99998 14.8935 4.77498 16.7852 6.32498 18.3352C7.87498 19.8852 9.76664 20.6602 12 20.6602Z",
    fill: "#1D4650"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoV2);
export default __webpack_public_path__ + "static/media/info-v2.4b8a1f826b298f7e972887e240dfac95.svg";
export { ForwardRef as ReactComponent };